import { FAR_TRAVEL_BASE_PATH } from "./far-travel-path.js";

/** The backend category name of far travel (case-insensitive, after decoding). */
export const FAR_TRAVEL_CATEGORY_NAME = "verreizen";

function decoded(value) {
  const raw = String(value ?? "").trim();
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function isFarTravelCategoryName(categoryName) {
  return decoded(categoryName).toLowerCase() === FAR_TRAVEL_CATEGORY_NAME;
}

/**
 * Listing path for a category: far travel is its own top-level category on
 * /verre-reizen, everything else stays /packages/<category>. The caller keeps
 * its own casing choice (`lowercase`) and wraps the result in localizeHref
 * where it did so before.
 */
export function categoryPath(categoryName, { lowercase = false } = {}) {
  if (isFarTravelCategoryName(categoryName)) return FAR_TRAVEL_BASE_PATH;
  const name = lowercase ? String(categoryName ?? "").toLowerCase() : String(categoryName ?? "");
  return `/packages/${encodeURIComponent(name)}`;
}
